export default __webpack_public_path__ + "806add748d8e47401ee609e12a29fa30.png";